module.exports = "<div> <holding-promotion-bonus-banner ng-if=showBonusPromotionBanner bonus=promoCode> </holding-promotion-bonus-banner> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/promotions/directives/promotions-pager/promotions-pager.html
// module id = 803
// module chunks = 0